import { render, staticRenderFns } from "./ConfirmationStep.vue?vue&type=template&id=3bca09c0&"
import script from "./ConfirmationStep.vue?vue&type=script&lang=js&"
export * from "./ConfirmationStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports